export interface TypesenseBusinessDocument {
  id: string;
  business_name: string;
  logo_url: string;
  cashback_value: number;
  cashback_display: string;
  partner_type: string;
  is_featured: boolean;
  brands: string[];
}

const TYPESENSE_BASE_URL = `${process.env.REACT_APP_TYPESENSE_PROTOCOL}://${process.env.REACT_APP_TYPESENSE_HOST}:${process.env.REACT_APP_TYPESENSE_PORT}`;
const TYPESENSE_API_KEY = process.env.REACT_APP_TYPESENSE_API_KEY || "";
const COLLECTION = process.env.REACT_APP_TYPESENSE_COLLECTION || "local_business";

const CHUNK_SIZE = 200;

async function typesenseMultiSearch(searches: any[]): Promise<any> {
  const response = await fetch(`${TYPESENSE_BASE_URL}/multi_search`, {
    method: "POST",
    headers: {
      "X-TYPESENSE-API-KEY": TYPESENSE_API_KEY,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ searches }),
  });
  return response.json();
}

export async function fetchBusinessesByIds(
  ids: string[]
): Promise<TypesenseBusinessDocument[]> {
  if (ids.length === 0) return [];

  const chunks: string[][] = [];
  for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
    chunks.push(ids.slice(i, i + CHUNK_SIZE));
  }

  const allDocs: Map<string, TypesenseBusinessDocument> = new Map();

  for (const chunk of chunks) {
    const filterBy = `id:[${chunk.join(",")}]`;
    const data = await typesenseMultiSearch([
      {
        collection: COLLECTION,
        q: "*",
        query_by: "business_name",
        filter_by: filterBy,
        per_page: CHUNK_SIZE,
      },
    ]);

    const hits = data.results?.[0]?.hits || [];
    for (const hit of hits) {
      const doc = hit.document as TypesenseBusinessDocument;
      allDocs.set(doc.id, doc);
    }
  }

  // Return in same order as input IDs
  return ids
    .map((id) => allDocs.get(id))
    .filter((doc): doc is TypesenseBusinessDocument => doc !== undefined);
}

export async function searchBusinesses(
  query: string,
  page: number = 1,
  perPage: number = 20
): Promise<{ results: TypesenseBusinessDocument[]; found: number }> {
  const data = await typesenseMultiSearch([
    {
      collection: COLLECTION,
      q: query.trim() || "*",
      query_by: "business_name",
      per_page: perPage,
      page,
    },
  ]);

  const searchResult = data.results?.[0];
  const results = (searchResult?.hits || []).map(
    (hit: any) => hit.document as TypesenseBusinessDocument
  );
  const found = searchResult?.found || 0;

  return { results, found };
}
